import script from "./BalImage.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalImage.vue?vue&type=script&lang=ts&setup=true"

import "./BalImage.vue?vue&type=style&index=0&id=095ba4cc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-095ba4cc"]])

export default __exports__